<template>
    <a-modal
            :title="title"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            okText="确定"
            cancelText="取消"
            @ok="handleSubmit"
            @cancel="handleCancel"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <p style="color: red">（提示：输入顾客手机号，点击查找，然后选择消费券类型）</p>
                <a-form-item
                        label="顾客手机号"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <a-input-search
                            v-model="phone"
                            enter-button="查找"
                            @change="handlePhoneChange"
                            @search="onSearchConsumer"
                            placeholder="输入顾客手机号"
                            v-decorator="['phone', {rules: [{required: true, min: 2, message: '手机号格式有误',
                    validator: (rule, value, cbfn) => {
                        var reg= /^1[3456789]\d{9}$/;
                        if(!reg.test(value))
                            cbfn('手机号格式有误')
                         cbfn()
                      }}]}]" />
                </a-form-item>
                <a-form-item
                        label="消费券类型"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    <span v-if="!searchSuccess">（查找后可选择）</span>
                    <span v-else>
                        <span v-if="Object.keys(coupons).length==0">该用户无可用消费券</span>
                        <a-dropdown v-else>
                            <a-menu slot="overlay" @click="handleCouponSelect">
                                <a-menu-item :key="coupon.couponValue" v-for="coupon in coupons"> <a-icon type="user" />{{coupon.couponValue}}元券（剩余{{coupon.count}}张）</a-menu-item>
                            </a-menu>
                            <a-button style="margin-left: 8px">
                                <span v-if="choosedCoupon.length === 0">选择消费券</span>
                                <span v-else>{{choosedCoupon[0].couponValue}}元券（剩余{{choosedCoupon[0].count}}张）</span>
                                <a-icon type="down" /> </a-button>
                        </a-dropdown>
                    </span>

                </a-form-item>
                <a-form-item
                             label="消费金额"
                             :labelCol="labelCol"
                             :wrapperCol="wrapperCol"
                >
                    <a-input type="number" placeholder="输入顾客消费金额" v-decorator="['consumeAmount', {rules: [{type: 'integer', required: true, min: 1, message: '消费金额需为整数，且最小为1', transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>

    import vendorAdminService from "../../../service/vendorAdmin"

    export default {
        data () {
            return {
                // formModal统一数据
                visible: false,
                title: "",
                modalData: {},
                confirmLoading: false,
                form: this.$form.createForm(this),

                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },

                phone: "",
                // 查找用户信息是否成功
                searchSuccess: false,
                coupons: [],
                // 用户选中的消费券
                choosedCoupon: []
            }
        },
        methods: {
            showForm(title, modalData) {
                this.form.resetFields()
                this.visible = true
                this.modalData = modalData
                this.title = title
            },

            handleSubmit () {
                if(this.choosedCoupon.length ===0) {
                    this.$message.error('尚未选择消费券');
                    return
                }

                const { form: { validateFields } } = this
                this.confirmLoading = true

                let vm = this
                validateFields((errors, values) => {
                    if (!errors) {
                        vendorAdminService.getConsumerInfo({phone: values.phone}).then((res)=>{
                            if(res.success) {
                                const h = vm.$createElement;
                                vm.$confirm({
                                    title: '请确认',
                                    content: h('div', {}, [
                                        h('p', "赠送信息如下："),
                                        h('p', `顾客手机号：${res.data.phone}`),
                                        h('p', `顾客昵称：${res.data.nickname}`),
                                        h('p', `消费金额：${values.consumeAmount}元`),
                                        h('b', `使用消费券：${vm.choosedCoupon[0].couponValue}元券（使用后剩余${vm.choosedCoupon[0].count - 1}张）`),
                                    ]),
                                    onOk() {
                                        vm.$emit('use', {consumerId: res.data.id, consumeCouponExchangeId: vm.choosedCoupon[0].id, consumeAmount: values.consumeAmount})
                                    },
                                    onCancel() {
                                        vm.confirmLoading = false
                                    },
                                    okText: "确定",
                                    cancelText: "取消"
                                });
                            } else {
                                const h = vm.$createElement;
                                vm.$warning({
                                    title: '赠送失败',
                                    content: h('div', {}, [
                                        h('p', res.message),
                                    ]),
                                    onOk() {},
                                    okText: "确定"
                                });
                                vm.confirmLoading = false
                            }
                        })
                        .catch((res)=>{
                            vm.confirmLoading = false
                        })
                        /*setTimeout(() => {
                            this.visible = false
                            this.confirmLoading = false
                            values.id = this.modalData.id
                            this.$emit(this.formType === "charge"?'charge':"deduct", values)
                        }, 200)*/
                    } else {
                        this.confirmLoading = false
                    }
                })
            },
            handleCancel () {
                this.visible = false
                this.searchSuccess = false
                this.choosedCoupon = []
            },

            onSearchConsumer() {
                let reg= /^1[3456789]\d{9}$/;
                let vm = this
                if(reg.test(this.phone)) {
                    vendorAdminService.getConsumerCouponInfo({phone: this.phone}).then((res)=>{
                        this.searchSuccess = true
                        let coupons = res.data;
                        let handledCoupons = {}
                        for(let coupon of coupons) {
                            if(typeof handledCoupons[coupon.couponValue] === "undefined") {
                                handledCoupons[coupon.couponValue] = coupon
                                handledCoupons[coupon.couponValue].count = 1
                            } else {
                                handledCoupons[coupon.couponValue].count++
                            }
                        }
                        vm.coupons = handledCoupons
                        console.log(vm.coupons)
                    })
                } else {
                    this.$message.error('手机号格式错误');
                }
            },
            handleCouponSelect(e) {
                this.choosedCoupon = []
                this.choosedCoupon.push(this.coupons[e.key])
            },
            handlePhoneChange(){
                this.searchSuccess = false
                this.coupons = []
                this.choosedCoupon = []
            }
        },
    }
</script>
